import { createReducer } from '../utils'

const initialState = {
  selections: [{
    label: '100% Upfront',
    clientLabel: '100% Upfront',
    creatorLabel: '100% Payment, 45 Days After Project Completed',
    upfrontAmount: 100,
    installment: 0,
    daysPayable: 0,
    installmentAmount: 0,
    period: 0,
    projectCost: 0,
    isVerified: false,
    value: 1,
    clientNotes: '100% Upfront payment before commencement of project',
    creatorNotes: '100% Payment within 45 days after project completion',
    emailActionSuccess: 'Please wait while we are preparing to send a separate email to manage your project.',
    emailCreatorAction: 'Please wait while we are preparing to send a separate email to manage your project. We will send the payment to you upon project completion.',
    emailPOCreator: 'Right now you can start managing the project.',
  }, {
    label: '50% Down Payment + 50% Settlement',
    clientLabel: '50% Down Payment + 50% Settlement, {{X}} Calendar Days Nett After Project Completed',
    creatorLabel: '50% Down Payment + 50% Settlement, {{X}} Days After Project Completed',
    upfrontAmount: 50,
    installment: 1,
    daysPayable: 0,
    installmentAmount: 50,
    period: 0,
    projectCost: 0,
    isVerified: true,
    value: 2,
    clientNotes: '50% Down Payment before commencement of project and 50% Final Settlement {{X}} days after project completion',
    creatorNotes: '50% Down Payment before commencement of project and 50% Final Settlement {{X}} days after project completion',
    emailUpfrontLabel: '50% Down Payment',
    emailSettlementLabel: '50% Final Settlement',
    emailActionSuccess: 'Please log in and continue managing the project.',
    emailActionFinal: 'Thank you for using our service.',
    emailCreatorAction: 'Please wait while our staff is sending the payment to you.',
    emailPOCreator: 'Right now you can start the project but please be advised that the client has not yet completed the payment process.',
  }, {
    label: '100% Settlement',
    clientLabel: '100% Settlement, {{X}} Calendar Days After Project Completed',
    creatorLabel: '100% Payment, {{X}} Days After Project Completed',
    upfrontAmount: 0,
    installment: 1,
    daysPayable: 0,
    installmentAmount: 100,
    period: 0,
    projectCost: 0,
    isVerified: true,
    value: 3,
    clientNotes: 'TOP 100% payment, {{X}} days after project completed',
    creatorNotes: '100% Payment within {{X}} days after project completion',
    emailActionSuccess: 'Please log in and continue managing the project.',
    emailCreatorAction: 'Please log in to continue manage the project and we will send the payment to you {{X}} days after the project completed.',
    emailPOCreator: 'Right now you can start the project but please be advised that the client has not yet completed the payment process.',
  }],
  payableDays: [{
    value: 30,
  }, {
    value: 60,
  }, {
    value: 90,
  }, {
    value: 120,
  }],
}

export default createReducer(initialState, {})

export function getTop(top) {
  try {
    const selected = initialState.selections.filter(each => (
      each.upfrontAmount === top.upfrontAmount &&
      each.installment === top.installment &&
      each.installmentAmount === top.installmentAmount
    ))[0]
    selected.daysPayable = top.daysPayable
    selected.clientLabel = selected.clientLabel.replace('{{X}}', top.daysPayable)
    selected.creatorLabel = selected.creatorLabel.replace('{{X}}', top.daysPayable + 15)
    selected.clientNotes = selected.clientNotes.replace('{{X}}', top.daysPayable)
    selected.creatorNotes = selected.creatorNotes.replace('{{X}}', top.daysPayable + 15)
    selected.emailCreatorAction = selected.emailCreatorAction.replace('{{X}}', top.daysPayable + 15)
    return selected
  } catch (e) {
    return false
  }
}
